import type { API } from 'chessboard/api/config/types';
import JCE from '@chesscom/js-chess-engine';

/**
 * Create the getJCEGameCopy method.
 */
export function createGetJCEGameCopy(context: API.Context) {
  /**
   * Create a copy of the current JCE game object and return it.
   */
  return function getJCEGameCopy(): JCE.Game {
    const { api } = context;
    const premoves = api.premoves?.getQueue() || [];

    const newGame = JCE.createGame({
      pgn: api.getPGN(),
      analysis: true,
      timestamps: api.times.get() || api.timestamps.get() || undefined,
    });

    if (!newGame) {
      throw new Error('Unable to create JCE game copy');
    }

    newGame.premove.queue.push(...premoves);

    return newGame;
  };
}
